import React, { useCallback } from 'react';
// import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
// import FileUploadIcon from '../svg/FileUploadIcon';
// import palette from '../theme/palette';
import { UploadSingleFile } from '../fl-components/upload';

// const useStyles = makeStyles({
//   uploadContainer: {
//     backgroundColor: palette.secondary.lighter,
//     border: '1px dashed',
//     borderColor: palette.secondary.main,
//     borderRadius: 8,
//     height: 80,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: '0 50px',
//     cursor: 'pointer'
//   }
// });

export default function FileUploadContainer({ onFileChange }) {
  // const classes = useStyles();
  // const [selFiles, setSelFile] = useState(null);
  // const fileInput = useRef();
  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];

      onFileChange(file);
      // if (file) {
      //   setValue(
      //     'cover',
      //     Object.assign(file, {
      //       preview: URL.createObjectURL(file),
      //     })
      //   );
      // }
    }
    // [setValue]
  );
  return (
    <>
      <UploadSingleFile
        accept="image/png, image/jpeg, .pdf"
        // file={field.value}
        // error={checkError}
        // helperText={
        //   checkError && (
        //     <FormHelperText error sx={{ px: 2 }}>
        //       {error.message}
        //     </FormHelperText>
        //   )
        // }
        onDrop={handleDrop}
        // {...other}
      />
      {/* <input
        type="file"
        accept="image/png, image/jpeg, .pdf"
        style={{ display: 'none' }}
        ref={fileInput}
        onChange={() => {
          // setSelFile(URL.createObjectURL(fileInput.current.files[0]));
          onFileChange(fileInput.current.files[0]);
        }}
      />
      <div
        role="presentation"
        className={classes.uploadContainer}
        onClick={() => fileInput.current.click()}
      >
        <FileUploadIcon color={palette.secondary.main} style={{ marginRight: 15 }} />{' '}
        <span style={{ fontSize: 14, color: palette.grey[600] }}>Supports: JPG, PNG, PDF</span>
      </div> */}
    </>
  );
}

FileUploadContainer.propTypes = {
  onFileChange: PropTypes.func
};
